/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyInterview,
  PharmacyInterviewFromJSON,
  PharmacyInterviewFromJSONTyped,
  PharmacyInterviewToJSON,
  PharmacyInterviewCounselingType,
  PharmacyInterviewCounselingTypeFromJSON,
  PharmacyInterviewCounselingTypeFromJSONTyped,
  PharmacyInterviewCounselingTypeToJSON,
  PharmacyMedicineNotebookClient,
  PharmacyMedicineNotebookClientFromJSON,
  PharmacyMedicineNotebookClientFromJSONTyped,
  PharmacyMedicineNotebookClientToJSON,
  PharmacyOptionalParameter,
  PharmacyOptionalParameterFromJSON,
  PharmacyOptionalParameterFromJSONTyped,
  PharmacyOptionalParameterToJSON,
} from "./";

export const PharmacyChainTypename = "PharmacyChain" as const;

/**
 *
 * @export
 * @interface PharmacyChain
 */
export interface PharmacyChain {
  /**
   *
   * @type {Array<number>}
   * @memberof PharmacyChain
   */
  allianceClinicIds?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof PharmacyChain
   */
  appName?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyChain
   */
  cutoffDay?: number;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  displayServiceNotification?: boolean;
  /**
   *
   * @type {string}
   * @memberof PharmacyChain
   */
  fqdn?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyChain
   */
  id?: number;
  /**
   *
   * @type {PharmacyInterview}
   * @memberof PharmacyChain
   */
  interviewSheet?: PharmacyInterview;
  /**
   *
   * @type {string}
   * @memberof PharmacyChain
   */
  introduceType?: PharmacyChainIntroduceTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  isBulkBillingTarget?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  isExceededFollowUpCharLimit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  isFollowUpOnly?: boolean;
  /**
   *
   * @type {PharmacyMedicineNotebookClient}
   * @memberof PharmacyChain
   */
  medicineNotebookClient?: PharmacyMedicineNotebookClient;
  /**
   *
   * @type {object}
   * @memberof PharmacyChain
   */
  messageProviderAuthentication?: object;
  /**
   *
   * @type {string}
   * @memberof PharmacyChain
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyChain
   */
  note?: string;
  /**
   *
   * @type {Array<PharmacyOptionalParameter>}
   * @memberof PharmacyChain
   */
  optionalParameters?: Array<PharmacyOptionalParameter>;
  /**
   *
   * @type {string}
   * @memberof PharmacyChain
   */
  privacyPolicyUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  requiredChildWeight?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  requiredDateOfBirth?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableChainAnnouncement?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableChainFollowUp?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableChildWeight?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableElapsedTime?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableIndividualDelivery?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableIntegratedCounseling?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableMccmDigitalPlatformPayment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableMedicineNotebook?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableOldPricing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableReceiptAssociation?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableRefill?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableReserverType?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableUnsupportedList?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChain
   */
  usableWaitingLabel?: boolean;
  /**
   *
   * @type {Array<PharmacyInterviewCounselingType>}
   * @memberof PharmacyChain
   */
  usageInterviewCounselingTypes?: Array<PharmacyInterviewCounselingType>;
  /**
   *
   * @type {string}
   * @memberof PharmacyChain
   */
  usageInterviewSheet?: PharmacyChainUsageInterviewSheetEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyChain
   */
  utmCampaignCode?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyChain
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyChainIntroduceTypeEnum {
  Web = "web",
  Line = "line",
  App = "app",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyChainUsageInterviewSheetEnum {
  Default = "default",
  Custom = "custom",
  Unused = "unused",
}

export function PharmacyChainFromJSON(json: any): PharmacyChain {
  return PharmacyChainFromJSONTyped(json, false);
}

export function PharmacyChainFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyChain {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyChainTypename,

    allianceClinicIds: !exists(json, "alliance_clinic_ids") ? undefined : json["alliance_clinic_ids"],
    appName: !exists(json, "app_name") ? undefined : json["app_name"],
    cutoffDay: !exists(json, "cutoff_day") ? undefined : json["cutoff_day"],
    displayServiceNotification: !exists(json, "display_service_notification")
      ? undefined
      : json["display_service_notification"],
    fqdn: !exists(json, "fqdn") ? undefined : json["fqdn"],
    id: !exists(json, "id") ? undefined : json["id"],
    interviewSheet: !exists(json, "interview_sheet") ? undefined : PharmacyInterviewFromJSON(json["interview_sheet"]),
    introduceType: !exists(json, "introduce_type") ? undefined : json["introduce_type"],
    isBulkBillingTarget: !exists(json, "is_bulk_billing_target") ? undefined : json["is_bulk_billing_target"],
    isExceededFollowUpCharLimit: !exists(json, "is_exceeded_follow_up_char_limit")
      ? undefined
      : json["is_exceeded_follow_up_char_limit"],
    isFollowUpOnly: !exists(json, "is_follow_up_only") ? undefined : json["is_follow_up_only"],
    medicineNotebookClient: !exists(json, "medicine_notebook_client")
      ? undefined
      : PharmacyMedicineNotebookClientFromJSON(json["medicine_notebook_client"]),
    messageProviderAuthentication: !exists(json, "message_provider_authentication")
      ? undefined
      : json["message_provider_authentication"],
    name: !exists(json, "name") ? undefined : json["name"],
    note: !exists(json, "note") ? undefined : json["note"],
    optionalParameters: !exists(json, "optional_parameters")
      ? undefined
      : (json["optional_parameters"] as Array<any>).map(PharmacyOptionalParameterFromJSON),
    privacyPolicyUrl: !exists(json, "privacy_policy_url") ? undefined : json["privacy_policy_url"],
    requiredChildWeight: !exists(json, "required_child_weight") ? undefined : json["required_child_weight"],
    requiredDateOfBirth: !exists(json, "required_date_of_birth") ? undefined : json["required_date_of_birth"],
    usableChainAnnouncement: !exists(json, "usable_chain_announcement") ? undefined : json["usable_chain_announcement"],
    usableChainFollowUp: !exists(json, "usable_chain_follow_up") ? undefined : json["usable_chain_follow_up"],
    usableChildWeight: !exists(json, "usable_child_weight") ? undefined : json["usable_child_weight"],
    usableElapsedTime: !exists(json, "usable_elapsed_time") ? undefined : json["usable_elapsed_time"],
    usableIndividualDelivery: !exists(json, "usable_individual_delivery")
      ? undefined
      : json["usable_individual_delivery"],
    usableIntegratedCounseling: !exists(json, "usable_integrated_counseling")
      ? undefined
      : json["usable_integrated_counseling"],
    usableMccmDigitalPlatformPayment: !exists(json, "usable_mccm_digital_platform_payment")
      ? undefined
      : json["usable_mccm_digital_platform_payment"],
    usableMedicineNotebook: !exists(json, "usable_medicine_notebook") ? undefined : json["usable_medicine_notebook"],
    usableOldPricing: !exists(json, "usable_old_pricing") ? undefined : json["usable_old_pricing"],
    usableReceiptAssociation: !exists(json, "usable_receipt_association")
      ? undefined
      : json["usable_receipt_association"],
    usableRefill: !exists(json, "usable_refill") ? undefined : json["usable_refill"],
    usableReserverType: !exists(json, "usable_reserver_type") ? undefined : json["usable_reserver_type"],
    usableUnsupportedList: !exists(json, "usable_unsupported_list") ? undefined : json["usable_unsupported_list"],
    usableWaitingLabel: !exists(json, "usable_waiting_label") ? undefined : json["usable_waiting_label"],
    usageInterviewCounselingTypes: !exists(json, "usage_interview_counseling_types")
      ? undefined
      : (json["usage_interview_counseling_types"] as Array<any>).map(PharmacyInterviewCounselingTypeFromJSON),
    usageInterviewSheet: !exists(json, "usage_interview_sheet") ? undefined : json["usage_interview_sheet"],
    utmCampaignCode: !exists(json, "utm_campaign_code") ? undefined : json["utm_campaign_code"],
  };
}

export function PharmacyChainToJSON(object?: PharmacyChain | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    alliance_clinic_ids: value.allianceClinicIds,
    app_name: value.appName,
    cutoff_day: value.cutoffDay,
    display_service_notification: value.displayServiceNotification,
    fqdn: value.fqdn,
    id: value.id,
    interview_sheet: PharmacyInterviewToJSON(value.interviewSheet),
    introduce_type: value.introduceType,
    is_bulk_billing_target: value.isBulkBillingTarget,
    is_exceeded_follow_up_char_limit: value.isExceededFollowUpCharLimit,
    is_follow_up_only: value.isFollowUpOnly,
    medicine_notebook_client: PharmacyMedicineNotebookClientToJSON(value.medicineNotebookClient),
    message_provider_authentication: value.messageProviderAuthentication,
    name: value.name,
    note: value.note,
    optional_parameters:
      value.optionalParameters === undefined
        ? undefined
        : (value.optionalParameters as Array<any>).map(PharmacyOptionalParameterToJSON),
    privacy_policy_url: value.privacyPolicyUrl,
    required_child_weight: value.requiredChildWeight,
    required_date_of_birth: value.requiredDateOfBirth,
    usable_chain_announcement: value.usableChainAnnouncement,
    usable_chain_follow_up: value.usableChainFollowUp,
    usable_child_weight: value.usableChildWeight,
    usable_elapsed_time: value.usableElapsedTime,
    usable_individual_delivery: value.usableIndividualDelivery,
    usable_integrated_counseling: value.usableIntegratedCounseling,
    usable_mccm_digital_platform_payment: value.usableMccmDigitalPlatformPayment,
    usable_medicine_notebook: value.usableMedicineNotebook,
    usable_old_pricing: value.usableOldPricing,
    usable_receipt_association: value.usableReceiptAssociation,
    usable_refill: value.usableRefill,
    usable_reserver_type: value.usableReserverType,
    usable_unsupported_list: value.usableUnsupportedList,
    usable_waiting_label: value.usableWaitingLabel,
    usage_interview_counseling_types:
      value.usageInterviewCounselingTypes === undefined
        ? undefined
        : (value.usageInterviewCounselingTypes as Array<any>).map(PharmacyInterviewCounselingTypeToJSON),
    usage_interview_sheet: value.usageInterviewSheet,
    utm_campaign_code: value.utmCampaignCode,
  };
}
